import { render, staticRenderFns } from "./3dSecure.vue?vue&type=template&id=071a0f6c&"
import script from "./3dSecure.vue?vue&type=script&lang=ts&"
export * from "./3dSecure.vue?vue&type=script&lang=ts&"
import style0 from "./3dSecure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
